<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-py-xs">
            <div v-if="name === 'btPesquisar'" class="crud-title">
              <translate>SEARCH_RECORDS</translate>
            </div>
            <div v-else-if="name === 'btNovo'" class="crud-title">
              <translate>NEW_REGISTRATION</translate>
            </div>
          </q-card-section>
          <q-card-section class="q-px-md">
            <span v-if="elements.length > 1">
              <q-expansion-item
                v-for="(el, i) in elements"
                :key="i"
                :icon="el.icon"
                :default-opened="i === 0"
                :label="el.label"
                header-class="bg-primary text-white rounded-borders"
                header-style="min-height: 38px; padding: 6px 16px;"
                group="ucCroup"
                class="pesquisa-collapsible mb-6 expansion-font"
                expand-icon-class="text-white"
              >
                <jt-dynamic-form
                  ref="dynamicForm"
                  :key="i"
                  :inputs="el.inputs"
                  :relacionamentos="el.relacionamentos"
                  :model="el.dadosForm"
                  :interface="el.nmInterface"
                  form-class="form dynamic"
                />
              </q-expansion-item>
            </span>
            <span v-if="elements.length == 1">
              <jt-dynamic-form
                ref="dynamicForm"
                :inputs="inputs"
                :relacionamentos="elements[0].relacionamentos"
                :model="elements[0].dadosForm"
                :interface="elements[0].nmInterface"
                form-class="form dynamic"
                @composition-button-click="onCompositionButtonClick"
              />
            </span>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <div
      v-if="forms[0] && forms[0].buttons.length > 0"
      class="row full-width q-col-gutter-lg justify-center q-py-md"
    >
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="limparForm">
          <translate>CLEAN</translate>
        </q-btn>
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        class="col-lg-2 col-md-3"
      >
        <q-btn class="full-width" color="info" @click="actionButton(button)">
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
    <composition-multi-form-modal
      v-show="showMultiFormBoundResidues"
      ref="boundResidue"
      titleTopBar="ADD_MORE_RESIDUE"
      addOneMoreItemButtonLabel="RESIDUE"
      :form="formConfig"
      :model="elements[0].dadosForm"
      :composicaos="elements[0].dadosForm.boundResidues"
      :nr-linha-selecionada="nrLinhaSelecionada"
      :fl-main-crud-in-change="isEditGenerator"
      :fl-composicao-alteracao="editMode"
      :non-changeable-fields="nonChangeableFields"
      :afterPerformItems="afterPerformItems"
    />
    <q-dialog v-model="showModalSign" persistent>
      <q-card>
        <q-card-section class="row justify-center">
          <q-icon name="error_outline" color="warning" size="4.5em"></q-icon>
        </q-card-section>
        <q-card-section class="row justify-center q-mx-lg">
          <span class="text-subtitle1 text-weight-medium text-center">{{
            this.messengerQuestionSignature
          }}</span>
        </q-card-section>
        <q-card-actions class="justify-center q-pa-md q-my-sm">
          <q-btn
            :label="$gettext('DIALOGS_NO')"
            color="grey-7"
            v-close-popup
            class="q-px-lg"
          />
          <q-btn
            :label="$gettext('DIALOGS_YES')"
            color="info"
            v-close-popup
            @click="sign()"
            class="q-px-lg"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="showModalReject" persistent>
      <q-card>
        <q-card-section class="q-py-sm">
          <div class="crud-title">
            <translate>INSERT_REASON_FOR_REJECTION</translate>
          </div>
        </q-card-section>
        <q-card-section>
          <textarea
            v-model="description"
            rows="5"
            cols="50"
            placeholder="Observação"
          >
          </textarea>
        </q-card-section>
        <q-card-actions class="justify-center q-pa-md q-my-sm">
          <q-btn
            :label="$gettext('CANCEL')"
            color="grey-7"
            v-close-popup
            class="q-px-lg"
          />
          <q-btn
            :label="$gettext('SEND')"
            color="info"
            v-close-popup
            @click="reject()"
            class="q-px-lg"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { JtCrud, JtDynamicForm } from 'jtech-webcomps'
import { repository, messageBox } from 'jtech'
import CompositionMultiFormModal from '../../../components/composition-multi-form-modal/CompositionMultiFormModal'
import moment from 'moment'
import { QDialog, Dialog } from 'quasar'
import ConsentLetterModel from './ConsentLetterModel.js'
const { page } = JtCrud

@Component({
  mixins: [page],
  name: 'ConsentLetterPage',
  components: { JtDynamicForm, CompositionMultiFormModal, QDialog, Dialog }
})
class ConsentLetterPage extends Vue {
  beforeDestroy () {
    this.state.setLandfill({})
    this.state.setClient({})
    this.state.setConsentLetterItens({})
  }

  state = ConsentLetterModel.getInstance()
  nmInterface = null
  showMultiFormBoundResidues = false
  showModalSign = false
  showModalReject = false;
  description = ''
  id = null
  messengerQuestionSignature = ''
  consentLetterSignatureParams = null
  params = null
  formConfig = null
  nrLinhaSelecionada = null
  editMode = false
  customCompositions = ['boundResidues']
  nonChangeableFields = []
  moment = moment
  compositionTable = null

  modalSign (consentLetterRegister) {
    this.showModalSign = true
    this.messengerQuestionSignature = this.$gettextInterpolate(
      this.$gettext('CONSENT_LETTER_SIGNATURE_SIGN'),
      { consentLetterRegister: consentLetterRegister }
    )
  }

  modalReject (consentLetterRegister) {
    this.showModalReject = true
    this.messengerQuestionSignature = this.$gettextInterpolate(
      this.$gettext('INSERT_REASON_FOR_REJECTION'),
      { consentLetterRegister: consentLetterRegister }
    )
  }

  async sign () {
    const consentLetterSignatureInterfaceSign = 'consentLetterSignature.sign'
    await this.refreshGridSignature(consentLetterSignatureInterfaceSign)
  }

  async reject () {
    const nonWhitespaceDescription = this.description.replace(/ {2,}/g, ' ')
    if (nonWhitespaceDescription.length < 15) {
      messageBox.warn(this.$gettext('CADRI_MINIMUM_CHARACTERS_ALERT'))
      return
    }
    const consentLetterSignatureInterfaceReject = 'consentLetterSignature.reject'
    await this.refreshGridSignature(consentLetterSignatureInterfaceReject)
  }

  async refreshGridSignature (consentLetterSignatureInterface) {
    let rowSignature
    try {
      const initialsData = await repository.resolveLogic(
        consentLetterSignatureInterface, this.consentLetterSignatureParams
      )
      rowSignature = this.compositionTable.composition.data.find(row => row.id == this.compositionTable.params.id)
      rowSignature.signatureType_nmDescricao = initialsData.nmDescricao
      rowSignature.signatureType = initialsData.signatureType
    } catch (error) {
      console.error(error)
    }
  }

  get inputs () {
    return this.prepareInputs(this.elements[0].inputs)
  }

  setReadOnlyInput (isReadOnly, model) {
    this.elements[0].inputs.find(i => i.model == model).readonly = isReadOnly
  }

  mounted () {
    this.initModels()
    this.nmInterface = this.elements[0].nmInterface.split('.')[1]
  }

  isObjectEmpty (object) {
    return object !== null && typeof object === 'object' && Object.keys(object).length === 0
  }

  initModels () {
    const { landfill, consentLetterItens } = this.state
    if (!this.isObjectEmpty(landfill)) {
      this.elements[0].dadosForm.landfill = landfill
      this.setReadOnlyInput(true, 'landfill')
      this.setReadOnlyInput(false, 'client')
    }

    if (!this.isObjectEmpty(consentLetterItens)) {
      this.$nextTick(() => {
        consentLetterItens.unitMeasureType = 20090001
        consentLetterItens.consentLetter = null
        consentLetterItens.flAlterado = 'N'
        consentLetterItens.nrLinhaSelecionada = 0
        consentLetterItens.__index = 0
        consentLetterItens.unitMeasureType_nmDescricao = 'Tonelada'
        consentLetterItens.quantityRemaining = consentLetterItens.quantityGeneration
        consentLetterItens.landfill = landfill
        this.elements[0].dadosForm.consentLetterItens = [consentLetterItens]
      })
    }

    this.$forceUpdate()
  }

  objectHasContent (object) {
    return !!object
  }

  async beforeMount () {
    const { client } = this.state
    if (!this.isObjectEmpty(client)) this.$set(this.elements[0].dadosForm, 'client', client ?? '')
    const initialsData = await repository.resolveLogic(
      'consentLetter.clearForm'
    )
    if (!this.forms[0].dadosForm.id) {
      this.forms[0].dadosForm.register = initialsData.register
    }
  }

  signConsentLetterSignature (action) {
    this.consentLetterSignatureParams = action.params
    this.modalSign(this.forms[0].dadosForm.register)
  }

  rejectConsentLetterSignature (action) {
    this.consentLetterSignatureParams = action.params
    this.modalReject(this.forms[0].dadosForm.register)
  }

  @Watch('landfill')
  handleLandfillChange (newLandfillValue) {
    this.limparForm()
    this.forms[0].dadosForm.landfill = newLandfillValue
    this.setReadOnlyInput(!newLandfillValue, 'client')
  }

  get landfill () {
    return this.forms[0]?.dadosForm?.landfill
  }

  get daysLetter () {
    return this.forms[0]?.dadosForm?.daysLetter
  }

  get periodQuantity () {
    return this.forms[0]?.dadosForm?.periodQuantity
  }

  get cadriEnd () {
    return this.forms[0]?.dadosForm?.cadriEnd
  }

  get cadriEmission () {
    return this.forms[0]?.dadosForm?.cadriEmission
  }

  get startDate () {
    return this.forms[0]?.dadosForm?.startDate
  }

  get hasConsentLetterWasteCertified () {
    return this.elements[0]?.dadosForm?.consentLetterWasteCertified != null
  }

  get inputsWasteCertified () {
    this.elements[0].inputs.map((input) => {
      if (
        ['cadriEmission', 'cadriEnd', 'process', 'cadriNumber', 'periodQuantity', 'cadriPeriod'].includes(
          input.name
        )
      ) {
        if (this.hasConsentLetterWasteCertified) {
          this.$set(input, 'readonly', true)
        }
        this.$set(input, 'required', true)
      }
    })
  }

  get isCadriIssued () {
    return this.elements[0]?.dadosForm?.consentLetterType == 20080003
  }

  get isEditGenerator () {
    return this.nmInterface === 'alterar'
  }

  prepareInputs (inputs) {
    this.prepareConsentLetterInputs(inputs)
    this.prepareCompositionsInputs(inputs)
    return inputs
  }

  prepareConsentLetterInputs (inputs) {
    // só vai ser readonly, se já não tiver dados
    this.setReadOnlyInput(true, 'client')
  }

  prepareCompositionsInputs (inputs) {
    inputs.forEach((input) => {
      if (this.customCompositions.includes(input.model)) {
        input.allowCustomEditModal = true
      }
    })
  }

  onCompositionButtonClick (eventObject) {
    this.compositionTable = eventObject
    const { button: clickedButton } = eventObject
    switch (clickedButton.name) {
      case 'icAdicionarComposicao':
        this.addResidues(eventObject)
        break
      case 'icAlterarComposicao':
        this.editResidue(eventObject)
        break
      case 'icRemoveRecordOnComposition':
        this.removeResidue(eventObject)
        break
      case 'btSign':
        this.signConsentLetterSignature(eventObject)
        break
      case 'btReject':
        this.rejectConsentLetterSignature(eventObject)
        break
      default:
        break
    }
  }

  addResidues (eventObject) {
    // if (!this.landfill) {

    // } else {
    //   this.editMode = false
    //   this.openMultiFormModal(eventObject)
    // }
  }

  editResidue (eventObject) {
    this.editMode = true
    this.nrLinhaSelecionada = eventObject.nrLinhaSelecionada
    this.openMultiFormModal(eventObject)
  }

  removeResidue (eventObject) {
    const { compositionId, params } = eventObject
    const clickedIndex =
      params && (params.__index || params.__index === 0)
        ? eventObject.params.__index
        : null
    const newResiduesArray = []
    this.elements[0].dadosForm[compositionId].forEach((residue) => {
      const isAlreadyASavedRecord = residue.id || residue.id === 0
      if (isAlreadyASavedRecord || residue.__index !== clickedIndex) {
        residue.__index = newResiduesArray.length
        newResiduesArray.push(residue)

        if (residue.__index === clickedIndex && isAlreadyASavedRecord) {
          console.error(
            'This button cant be used when the process is different from add a new generator'
          )
        }
      }
    })
    this.elements[0].dadosForm[compositionId] = newResiduesArray
    this.nrLinhaSelecionada = null
  }

  openMultiFormModal (eventObject) {
    const { compositionId, formConfig } = eventObject
    if (this.customCompositions.includes(compositionId)) {
      this.formConfig = formConfig
      if (compositionId === 'boundResidues') {
        this.showMultiFormBoundResidues = true
      }
      this.$nextTick(() => {
        this.$refs[compositionId.substring(0, compositionId.length - 1)].show()
      })
    }
  }

  afterPerformItems () {
    this.showMultiFormBoundResidues = false
    this.$refs.boundResidue.hide()
  }

  @Watch('daysLetter')
  onDaysLetterChange () {
    this.addDaysEndDate()
  }

  @Watch('cadriEnd', { deep: true })
  onEndDateChange () {
    this.handlePeriodQuantity()
  }

  calculateEndDate (initialDate, period, unit) {
    if (initialDate && period) {
      const momentDate = this.moment(initialDate, ['DD/MM/YYYY', 'YYYY-MM-DD'], true)

      if (momentDate.isValid()) {
        return this.moment(initialDate, 'DD/MM/YYYY').add(period, unit).format('DD/MM/YYYY')
      } else {
        return this.moment(initialDate, 'YYYY-MM-DD').add(period, unit).format('DD/MM/YYYY')
      }
    }
    return null
  }

  addEndDateFromDays (initialDate, days) {
    return this.calculateEndDate(initialDate, days, 'd')
  }

  addEndDateFromYears (initialDate, years) {
    return this.calculateEndDate(initialDate, years, 'y')
  }

  addDaysEndDate () {
    this.forms[0].dadosForm.endDate = this.addEndDateFromDays(this.startDate, this.daysLetter)
  }

  @Watch('cadriEmission')
  onStartDateCadriChange () {
    this.forms[0].dadosForm.cadriStart = this.forms[0]?.dadosForm?.cadriEmission
    this.handlePeriodQuantity()
  }

  handlePeriodQuantity () {
    if (this.cadriEnd && this.cadriEmission) {
      const yearEndDate = this.moment(this.cadriEnd, 'DD/MM/YYYY')
      const yearCadriEmission = this.moment(this.cadriEmission, 'DD/MM/YYYY')
      this.forms[0].dadosForm.periodQuantity = yearEndDate.diff(yearCadriEmission, 'years')
    }
  }
}
export default ConsentLetterPage
</script>
<style lang='stylus'>
@import '~quasar-variables';

.container-consentletter {
  #scroll-area {
    height: calc(35vh - 12px) !important;
  }
}

.jt-datatable {
  .hidden-row > div {
    width: 100%;
    padding: 5px 12px;
  }

  .hidden-row > div:nth-child(odd) {
    background-color: $grey-3;
  }

  .q-table--no-wrap td {
    white-space: inherit !important;
  }
}
</style>
